/* CsakCsajok morfoló főmenü – asztali lenyíló + mobil alsó panel. 2026-10-21 perf2: a snippets/cc-mega-menu.liquid-ból kiemelve (defer). */
(function () {
  function hydrate(root) {
    if (!root) return;
    root.querySelectorAll('img[data-src]').forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
  }

  function initDesktop() {
    var nav = document.querySelector('[data-cc-mm]');
    if (!nav || nav.__ccInit) return;
    nav.__ccInit = true;
    var header = nav.closest('header') || nav.parentElement;
    var pos = nav.querySelector('[data-cc-pos]');
    var box = pos.querySelector('.cc-mm-box');
    var arrow = pos.querySelector('.cc-mm-arrow');
    var trigs = Array.prototype.slice.call(nav.querySelectorAll('.cc-mm-trig'));
    var panes = {}, order = [];
    nav.querySelectorAll('.cc-mm-pane').forEach(function (p) { panes[p.dataset.key] = p; order.push(p.dataset.key); });
    var current = null, openT = 0, closeT = 0, lastPointer = 'mouse';

    function trigFor(key) { return nav.querySelector('.cc-mm-trig[data-key="' + key + '"]'); }
    function open(key) {
      clearTimeout(closeT);
      if (!panes[key]) { close(); return; }
      if (current === key) return;
      var pane = panes[key], trig = trigFor(key);
      hydrate(pane);
      var hr = header.getBoundingClientRect(), tr = trig.getBoundingClientRect();
      var w = Math.min(pane.offsetWidth, hr.width - 32), h = pane.offsetHeight;
      var center = tr.left - hr.left + tr.width / 2;
      var x = Math.max(16, Math.min(Math.round(center - w / 2), Math.round(hr.width - w - 16)));
      var wasOpen = current !== null;
      pos.classList.toggle('is-instant', !wasOpen);
      pos.style.transform = 'translateX(' + x + 'px)';
      box.style.width = w + 'px';
      box.style.height = h + 'px';
      arrow.style.transform = 'translateX(' + Math.round(center - x - 7) + 'px) rotate(45deg)';
      if (!wasOpen) box.style.transformOrigin = Math.round(center - x) + 'px 0';
      var idx = order.indexOf(key);
      order.forEach(function (k) {
        var el = panes[k];
        if (k === key) { el.classList.add('is-active'); el.removeAttribute('data-side'); el.removeAttribute('inert'); }
        else { el.classList.remove('is-active'); el.setAttribute('data-side', order.indexOf(k) < idx ? 'left' : 'right'); el.setAttribute('inert', ''); }
      });
      trigs.forEach(function (t) { if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', String(t.dataset.key === key)); });
      pos.classList.add('is-open');
      if (!wasOpen) requestAnimationFrame(function () { requestAnimationFrame(function () { pos.classList.remove('is-instant'); }); });
      current = key;
    }
    function close() {
      clearTimeout(openT);
      pos.classList.remove('is-open');
      trigs.forEach(function (t) { if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false'); });
      current = null;
    }
    order.forEach(function (k) { panes[k].setAttribute('inert', ''); });

    nav.addEventListener('pointerover', function (e) {
      pos.classList.remove('is-kbd');
      lastPointer = e.pointerType || 'mouse';
      if (lastPointer !== 'mouse') return;
      var t = e.target.closest('.cc-mm-trig');
      if (!t) return;
      clearTimeout(closeT); clearTimeout(openT);
      if (current) open(t.dataset.key);
      else openT = setTimeout(function () { open(t.dataset.key); }, 80);
    });
    nav.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
    nav.addEventListener('click', function (e) {
      var t = e.target.closest('.cc-mm-trig');
      if (!t || !panes[t.dataset.key]) return;
      if (lastPointer !== 'mouse' && current !== t.dataset.key) { e.preventDefault(); open(t.dataset.key); }
    });
    nav.addEventListener('keydown', function (e) {
      var t = e.target.closest('.cc-mm-trig');
      if (t && e.key === 'ArrowDown' && panes[t.dataset.key]) {
        e.preventDefault(); pos.classList.add('is-kbd'); open(t.dataset.key);
        var f = panes[t.dataset.key].querySelector('a'); if (f) setTimeout(function () { f.focus(); }, 30);
      }
      if (t && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        var i = trigs.indexOf(t), n = trigs[(i + (e.key === 'ArrowRight' ? 1 : -1) + trigs.length) % trigs.length];
        n.focus(); if (current) { pos.classList.add('is-kbd'); open(n.dataset.key); }
      }
      if (e.key === 'Escape' && current) { var k = current; close(); var tr = trigFor(k); if (tr) tr.focus(); }
    });
    header.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { clearTimeout(openT); closeT = setTimeout(close, 220); } });
    header.addEventListener('pointerenter', function () { clearTimeout(closeT); });
    header.addEventListener('focusout', function (e) { if (current && e.relatedTarget && !nav.contains(e.relatedTarget)) close(); });
    document.addEventListener('click', function (e) { if (current && !nav.contains(e.target)) close(); });
    window.addEventListener('resize', close);

    function swap(pane, url, cap) {
      var pv = pane.querySelector('.cc-mm-pv');
      if (!pv || !url) return;
      var imgs = pv.querySelectorAll('img'), a = imgs[0], b = imgs[1];
      var front = pv.getAttribute('data-front') === 'b' ? b : a, back = front === a ? b : a;
      if (front.getAttribute('data-k') === url) return;
      back.src = url; back.setAttribute('data-k', url);
      back.classList.add('on'); front.classList.remove('on');
      pv.setAttribute('data-front', back === a ? 'a' : 'b');
      var t = pv.querySelector('.cc-mm-pv-t'); if (t && cap) t.textContent = cap;
    }
    function hot(e) {
      var it = e.target.closest('[data-pv]');
      if (!it) return;
      var pane = it.closest('.cc-mm-pane');
      pane.querySelectorAll('.is-hot').forEach(function (x) { x.classList.remove('is-hot'); });
      var wrap = it.closest('.cc-mm-it'); if (wrap) wrap.classList.add('is-hot');
      swap(pane, it.getAttribute('data-pv'), it.getAttribute('data-cap'));
    }
    box.addEventListener('pointerover', hot);
    box.addEventListener('focusin', hot);
  }

  function initSheet() {
    var sheet = document.querySelector('[data-cc-sheet]:not([data-cc-ready])');
    if (!sheet) return;
    var scrim = sheet.previousElementSibling && sheet.previousElementSibling.matches('[data-cc-scrim]') ? sheet.previousElementSibling : null;
    document.querySelectorAll('body > [data-cc-sheet][data-cc-ready], body > [data-cc-scrim][data-cc-ready]').forEach(function (n) { n.remove(); });
    sheet.setAttribute('data-cc-ready', '');
    if (scrim) { scrim.setAttribute('data-cc-ready', ''); document.body.appendChild(scrim); }
    document.body.appendChild(sheet);
    var body = sheet.querySelector('[data-cc-sbody]'), title = sheet.querySelector('#ccMmSheetTitle'), stop = sheet.querySelector('.cc-mm-stop');
    var lv = {}, cur = null, opener = null, sheetCloseT = 0;
    sheet.querySelectorAll('.cc-mm-lvl').forEach(function (l) { lv[l.getAttribute('data-lvl')] = l; });

    function fit() {
      if (!cur) return;
      var el = lv[cur];
      el.style.height = 'auto';
      var need = el.scrollHeight;
      el.style.height = '';
      var avail = Math.round(window.innerHeight * 0.88) - stop.offsetHeight - 16;
      body.style.height = Math.min(need, avail) + 'px';
    }
    function show(key, back) {
      var next = lv[key], prev = cur ? lv[cur] : null;
      if (!next) return;
      hydrate(next);
      if (prev && prev !== next) { prev.classList.remove('is-active'); prev.classList.toggle('is-left', !back); prev.setAttribute('inert', ''); }
      next.classList.remove('is-left'); next.classList.add('is-active'); next.removeAttribute('inert'); next.scrollTop = 0;
      cur = key; fit();
      title.textContent = next.getAttribute('data-title') || 'Menü';
    }
    function openSheet(btn) {
      opener = btn || null;
      Object.keys(lv).forEach(function (k) { lv[k].classList.remove('is-active', 'is-left'); lv[k].setAttribute('inert', ''); });
      cur = null;
      clearTimeout(sheetCloseT); sheet.classList.remove('cc-mm-closing');
      document.documentElement.classList.add('cc-mm-lock');
      show('root');
      document.querySelectorAll('[data-cc-burger]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { var c = sheet.querySelector('[data-cc-close]'); if (c) c.focus({ preventScroll: true }); }, 60);
    }
    function closeSheet() {
      if (!document.documentElement.classList.contains('cc-mm-lock')) return;
      sheet.classList.add('cc-mm-closing'); clearTimeout(sheetCloseT);
      sheetCloseT = setTimeout(function () { sheet.classList.remove('cc-mm-closing'); }, 460); // a csúszás végéig látszik a tartalom
      document.documentElement.classList.remove('cc-mm-lock');
      document.querySelectorAll('[data-cc-burger]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (opener) opener.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cc-burger]');
      if (b) { e.preventDefault(); openSheet(b); }
    });
    if (scrim) scrim.addEventListener('click', closeSheet);
    sheet.querySelector('[data-cc-close]').addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (e) {
      var go = e.target.closest('[data-go]');
      if (go) { show(go.getAttribute('data-go')); return; }
      if (e.target.closest('[data-cc-back]')) { show('root', true); return; }
      if (e.target.closest('[data-cc-search]')) {
        closeSheet();
        var s = document.querySelector('.js-search-open-trigger');
        if (s) setTimeout(function () { s.click(); }, 120);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !document.documentElement.classList.contains('cc-mm-lock')) return;
      sheet.classList.add('is-drag'); if (scrim) scrim.classList.add('is-drag');
      closeSheet();
      requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.remove('is-drag'); if (scrim) scrim.classList.remove('is-drag'); }); });
    });
    (function dragToClose() {
      var zone = [sheet.querySelector('.cc-mm-grab'), stop].filter(Boolean);
      var startY = 0, dy = 0, t0 = 0, id = null, h = 1;
      function down(e) {
        if (id !== null || (e.pointerType === 'mouse' && e.button !== 0)) return;
        if (e.target.closest('button,a,input')) return;
        id = e.pointerId; startY = e.clientY; dy = 0; t0 = performance.now(); h = sheet.offsetHeight || 1;
        e.currentTarget.setPointerCapture(id);
        sheet.classList.add('is-drag'); if (scrim) scrim.classList.add('is-drag');
      }
      function move(e) {
        if (e.pointerId !== id) return;
        var raw = e.clientY - startY;
        dy = raw < 0 ? -Math.sqrt(-raw) * 2 : raw; /* felfelé: súrlódás, nem fal */
        sheet.style.transform = 'translateY(' + dy + 'px)';
        if (scrim) scrim.style.opacity = String(Math.max(0, 1 - Math.max(0, dy) / h));
      }
      function up(e) {
        if (e.pointerId !== id) return;
        id = null;
        var v = Math.max(0, dy) / Math.max(1, performance.now() - t0);
        sheet.classList.remove('is-drag'); if (scrim) scrim.classList.remove('is-drag');
        sheet.style.transform = ''; if (scrim) scrim.style.opacity = '';
        if (dy > h * 0.3 || v > 0.11) closeSheet();
      }
      zone.forEach(function (z) {
        z.addEventListener('pointerdown', down);
        z.addEventListener('pointermove', move);
        z.addEventListener('pointerup', up);
        z.addEventListener('pointercancel', up);
      });
    })();
    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 1100px)').matches) closeSheet(); else fit();
    });
  }

  function init() { initDesktop(); initSheet(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
